import React from "react";
import { ReactNode } from "react";

type CommonModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
};

const NewsModal: React.FC<CommonModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-white rounded-lg shadow-lg p-4 w-[856px] max-h-[90vh]  z-10">
        <div className="flex justify-between items-center mb-4 relative">
          <h1 className="text-xl font-bold">{title}</h1>
          <button
            onClick={onClose}
            className={`text-black hover:text-gray-700 absolute -top-2 right-1 text-3xl cursor-pointer z-[100]`}
          >
            <span>&times;</span>
          </button>
        </div>
        <div className="overflow-y-auto max-h-[80vh]">{children}</div>
      </div>
    </div>
  );
};

export default NewsModal;
